import { getPreSelectedChannelId } from '../channelsSelectors';
import { resetPreSelectedChannelId } from '../channelsSlice';
import changeSelectedChannelId from './changeSelectedChannelId';

const changeSelectedChannelToPreselectedChannel =
  ({ channelId }) =>
  async (dispatch, getState) => {
    const preSelectedChannelId = getPreSelectedChannelId(getState());

    if (preSelectedChannelId === channelId) {
      dispatch(changeSelectedChannelId({ selectedChannelId: preSelectedChannelId }));
      dispatch(resetPreSelectedChannelId);
    }
  };

export default changeSelectedChannelToPreselectedChannel;
